import { render, staticRenderFns } from "./ModifyUser.vue?vue&type=template&id=8f8901f2"
import script from "./ModifyUser.vue?vue&type=script&lang=js"
export * from "./ModifyUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports